import React from "react";
import PropTypes from "prop-types";
import { UserContainer, UserTitle, UserSubTitle } from "./userInfoStyles.js";

export const UserInfo = ({ userName, vendorName }) => {
  return (
    <UserContainer>
      <UserTitle>{userName}</UserTitle>
      <UserSubTitle>{vendorName}</UserSubTitle>
    </UserContainer>
  );
};

UserInfo.propTypes = {
  userName: PropTypes.string,
  vendorName: PropTypes.string,
};
UserInfo.defaultProps = {
  userName: "Robert Smith",
  vendorName: "Anderson",
};
